exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-8926acda]{padding:0 0.12rem;margin:0.3rem auto 0.6rem auto\n}\n", "", {"version":3,"sources":["/home/runner/work/web/web/b2c-customer-mobile/src/components/package/pagination.vue"],"names":[],"mappings":";AAqEA,6BACE,kBACA,8BAA+B;CAChC","file":"pagination.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.pagination {\n  padding: 0 0.12rem;\n  margin: 0.3rem auto 0.6rem auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8926acda","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/package/pagination.vue
// module id = RT0B
// module chunks = 0